<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<h1>{{ locale.translations['user']['user-process']['n241'] }}</h1>

		<p *ngIf="subject === 'phone'">
			{{ locale.translations['user']['user-process']['n242'] }}

			<ng-container *ngIf="viewport.type !== 'mobile'">
				{{ locale.translations['user']['user-process']['n255'] }}
			</ng-container>
		</p>

		<p *ngIf="subject === 'phone' && viewport.type === 'mobile'">
			{{ locale.translations['user']['user-process']['n255'] }}
		</p>

		<p *ngIf="subject === 'phone' || subject === 'incorrectPhone'">
			{{ locale.translations['user']['user-process']['n243'] }}
		</p>
    </div>

    <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" class="suffix" hideRequiredMarker>
                        <input #phoneInput matInput required dir="ltr" type="tel" pattern="[0-9]{0,}" minlength="11" maxlength="11" (focus)="phoneInput.setSelectionRange(phoneInput.value.length, phoneInput.value.length)" (keyup)="onKeyUp('altPhone')" [ngStyle]="{'text-align': locale.lang === 'en' ? 'left' : 'right'}" formControlName="altPhone">
                        <i class="fas fa-phone-alt" [ngClass]="{'pos-ltr': locale.lang === 'en', 'pos-rtl': locale.lang !== 'en'}"></i>
					</mat-form-field>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<button mat-flat-button type="submit" color="primary" [disabled]="!form.valid || loading || this.form.controls['altPhone'].value.length == '1'">{{ locale.translations['place-ad']['finish']['n77'] }}</button>
				</div>
			</div>
		</form>
	</div>
</div>
